export const homeCardClientReportFields = [
  {
    id: 5,
    title: 'Agenda',
    field: 'clientesAgendados',
    isButton: true,
  },
  {
    id: 1,
    title: 'Estratégia de Venda',
    field: 'clientesPeriodo',
    isButton: true,
  },
  {
    id: 2,
    title: 'Inativos há 1 mês',
    field: 'clientes1m',
    isButton: true,
  },
  {
    id: 3,
    title: 'Inativos há 3 meses',
    field: 'clientes3m',
    isButton: true,
  },
  {
    id: 4,
    title: 'Inativos há 6 meses',
    field: 'clientes6m',
    isButton: true,
  },
]
